var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedure2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 18.5,
    fill: "#33878E"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 18.0889,
    stroke: "url(#paint0_linear_1966_29081)",
    strokeOpacity: 0.83,
    strokeWidth: 0.822222,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1966_29081)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "url(#paint1_linear_1966_29081)",
    fillOpacity: 0.83,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.56162,
    y: 6.56162,
    width: 37.8768,
    height: 37.8768,
    rx: 18.9384,
    stroke: "url(#paint2_linear_1966_29081)",
    strokeOpacity: 0.83,
    strokeWidth: 0.876757,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9974 29.6673C28.5557 28.2618 29.5564 27.2725 29.9995 26.6996C30.4425 26.1267 30.6641 25.5576 30.6641 24.9923C30.6641 24.4423 30.4655 23.9687 30.0682 23.5715C29.671 23.1743 29.1974 22.9757 28.6474 22.9757C28.3266 22.9757 28.0172 23.0406 27.7193 23.1704C27.4214 23.3003 27.1807 23.4798 26.9974 23.709C26.8141 23.4798 26.5773 23.3003 26.287 23.1704C25.9967 23.0406 25.6835 22.9757 25.3474 22.9757C24.7974 22.9757 24.3238 23.1743 23.9266 23.5715C23.5293 23.9687 23.3307 24.4423 23.3307 24.9923C23.3307 25.2826 23.3689 25.55 23.4453 25.7944C23.5217 26.0388 23.6898 26.3253 23.9495 26.6538C24.2092 26.9822 24.5797 27.3833 25.0609 27.8569C25.5422 28.3305 26.1877 28.934 26.9974 29.6673ZM26.9974 35.1673C24.8738 34.6326 23.1207 33.4142 21.738 31.5121C20.3554 29.61 19.6641 27.4979 19.6641 25.1757V19.584L26.9974 16.834L34.3307 19.584V25.1757C34.3307 27.4979 33.6394 29.61 32.2568 31.5121C30.8741 33.4142 29.121 34.6326 26.9974 35.1673ZM26.9974 33.2423C28.5863 32.7381 29.9002 31.7298 30.9391 30.2173C31.978 28.7048 32.4974 27.0243 32.4974 25.1757V20.8444L26.9974 18.7819L21.4974 20.8444V25.1757C21.4974 27.0243 22.0168 28.7048 23.0557 30.2173C24.0946 31.7298 25.4085 32.7381 26.9974 33.2423Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1966_29081",
    x: -235.137,
    y: -236.139,
    width: 523.274,
    height: 523.277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.250309
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12886
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1966_29081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1966_29081",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1966_29081",
    x1: 9.99231,
    y1: 12.7429,
    x2: 22.7695,
    y2: 40.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0865385,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697115,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1966_29081",
    x1: 9.99231,
    y1: 12.7429,
    x2: 22.7695,
    y2: 40.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352567,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1966_29081",
    x1: 9.99231,
    y1: 12.7429,
    x2: 16.5838,
    y2: 42.6093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697115,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white",
    stopOpacity: 0.56
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedure2);
export default __webpack_public_path__ + "static/media/procedure2.6372be7db880a129bb57ab564cebc636.svg";
export { ForwardRef as ReactComponent };